import React from 'react';
import { Table } from 'semantic-ui-react';
import localization from '../../../../locales/localization';

export default class FixedIzdatnicaHeaderCells extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Table.HeaderCell textAlign="center" collapsing>
                    {localization.common.kolicina}
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center">{localization.izdatnice.jedinicnaNabavnaCijena}</Table.HeaderCell>
                <Table.HeaderCell textAlign="center" collapsing>
                    {localization.izdatnice.nabavnaCijena}
                </Table.HeaderCell>
            </React.Fragment>
        );
    }
}
